export default {
  toasts: {
    verification_pending: 'Deine Verifizierung ist noch ausstehend',
  },
};
